import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { TherapielandTreatmentCategory } from '../../../../../../common/enums/therapielandTreatmentCategory';
import { RequestCounselingReadButtons } from '../../../../elements/carePathButtons/RequestCounselingReadButtons';
import { FormParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { TreatmentList } from './GgzbTherV1TreatmentList';

export function GgzbTherV1RequestReadDraft(props: ICustomControlRequestReadProps) {
    const checkedTreatments = props.request.customControlData.checkedTreatments;

    return (
        <>
            <TreatmentList
                category={TherapielandTreatmentCategory.volwassenen}
                checkedTreatments={checkedTreatments}
                label={"Programma's voor volwassenen"}
            />
            <TreatmentList
                category={TherapielandTreatmentCategory.kindJeugd}
                checkedTreatments={checkedTreatments}
                label={"Programma's voor kind & jeugd"}
            />
            <TreatmentList
                category={TherapielandTreatmentCategory.lvb}
                checkedTreatments={checkedTreatments}
                label={"Programma's jongeren en jongvolwassenen met een licht verstandelijke beperking"}
            />
            <HorizontalFormGroupRead>
                <FormLabel>E-mailadres</FormLabel>
                <InputContainer>
                    <FormParagraph>{props.request.customControlData.emailadres}</FormParagraph>
                </InputContainer>
            </HorizontalFormGroupRead>

            <RequestCounselingReadButtons
                {...props}
                invitations={null}
            />
        </>
    );
}
